import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import { IconRemove } from '../../../components/icons/IconRemove';
import { ThreadOptionsStructure } from '../ThreadOptionStructure';
import type { AdminMessageRemoverProps } from './AdminMessageRemover';
import { AdminMessageRemover } from './AdminMessageRemover';

const messages = defineMessages({
  deleteLabel: { defaultMessage: 'Delete the message', id: '3Rbukn' },
  as: { defaultMessage: 'as an administrator', id: 'AWbgii' },
  asModerator: { defaultMessage: 'as a moderator', id: 'thJ0ht' },
});

export const AdminDeleteMessageOption: React.FC<AdminMessageRemoverProps> = props => {
  return (
    <AdminMessageRemover {...props}>
      <ThreadOptionsStructure
        icon={<IconRemove size="m" />}
        title={<FormattedMessage {...messages.deleteLabel} />}
        subtitle={
          <FormattedMessage {...(props.asModerator ? messages.asModerator : messages.as)} />
        }
      />
    </AdminMessageRemover>
  );
};
